import { AUTHORITY_URL, CLIENT_ID, REDIRECT_URL, TENANT_ID } from './configuration'

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID, // Your Azure AD App client ID
    authority: `${AUTHORITY_URL}/${TENANT_ID}`, // Or "https://login.microsoftonline.com/common" for multi-tenant
    redirectUri: REDIRECT_URL, // The URL to redirect to after login
  },
  cache: {
    cacheLocation: 'sessionStorage', // Cache location: "localStorage" or "sessionStorage"
    storeAuthStateInCookie: true, // Set to true if issues with cookies in certain browsers
  },
}
export const loginRequest = {
  // scopes: ["openid", "profile", "User.Read"]
  scopes: ['User.Read']
  //scopes: ["api://717cba96-fe8a-4115-aae1-b19fedaab37b/RhyBus.User"], // Scopes you need for access
//  scopes: ["api://715f13a4-1152-4161-a42a-230cb6443630/RhyBus.User"] // Scopes you need for access

 // Working
 //  scopes: ["api://9721e205-c18f-4526-a14b-eac8e7684f8f/User.Read"], /
}
export const apiRequest = {
  scopes: ['User.Read'], // Scopes you need for access
  // scopes: ['api://717cba96-fe8a-4115-aae1-b19fedaab37b/RhyBus.User'],
}

export const graphApiEndpoint = 'https://graph.microsoft.com/v1.0/me'
